module.exports = __webpack_public_path__ + "media/images/users/purchases/purchase_benefit_2-e81a74309213124d73469c3b08279588.png";